import { LightningElement, api, wire } from "lwc";
import { MenuAdapter, MENU_ADAPTER_DEFAULT_VALUE } from "common/menuAdapter";
import { assignedSlotNames } from "common/slot";
import { createTrack } from "common/track";
import { attrToBool, hash } from "common/helpers";
import { withImageProxy } from "common/withImageProxy";

class userMenu extends LightningElement {
  @wire(MenuAdapter, {
    template: "$template",
    items: "$menuItems",
  })
  menu = MENU_ADAPTER_DEFAULT_VALUE;

  @api get open() {
    return this.menu.state.open;
  }

  set open(value) {
    attrToBool(value) ? this.menu.open() : this.menu.close();
  }

  @api fullName = undefined;
  @api menuOptions = [];
  @api bannerPhotoUrl = undefined;
  @api avatarUrl = undefined;
  @api logoutLabel = undefined;
  @api logoutHref = undefined;
  track = createTrack(this);
  proxyAvatarURL = "";

  async connectedCallback() {
    this.proxyAvatarURL = await withImageProxy(this.avatarUrl);
  }

  get hasCustomTrigger() {
    return this.activeSlots.includes("trigger");
  }

  activeSlots = []; // This is for the MenuAdapter since the logout item is not part of `menuOptions`

  get menuItems() {
    return this.menuOptions.concat({
      href: "#",
      label: "logout",
    });
  }

  get options() {
    return this.menuOptions.map(
      (
        option // HACK: For some reason, using the spread operator causes Chromatic break
      ) =>
        Object.assign({}, option, {
          key: `item_${hash(option.label)}`,
        })
    );
  }

  get bannerStyle() {
    return `background-image: url(${this.bannerPhotoUrl});`;
  }

  get bannerPhotoStyle() {
    return `background-image: url(${this.proxyAvatarURL});`;
  }

  onSlotChange() {
    this.activeSlots = assignedSlotNames(this.template);
  }

  handleLinkClick(e) {
    const item = e.target;
    this.track("link_clicked", {
      label: item.textContent,
      href: item.getAttribute("href"),
    });
  }
}

export default userMenu;
